define(['sandbox', 'ember', 'logger'], function (sandbox, Ember, logger) {
  'use strict';
  var log = logger.getDefaultLogger();


  return Ember.ObjectController.extend({


  });
});